import SiteLayout from "@/components/layout/SiteLayout";
import HeroSection from "@/components/HeroSection";
import MissionSection from "@/components/MissionSection";
import TrustStrip from "@/components/TrustStrip";
import ServicesSection from "@/components/ServicesSection";
import FeaturedProperty from "@/components/FeaturedProperty";
import DRInvestSection from "@/components/DRInvestSection";
import PropertyPrepSection from "@/components/PropertyPrepSection";
import AboutPreviewSection from "@/components/AboutPreviewSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import AreasWeServeSection from "@/components/AreasWeServeSection";
import MapSection from "@/components/MapSection";
import FinalCTASection from "@/components/FinalCTASection";

const Index = () => {
  return (
    <SiteLayout>
      <HeroSection />
      <TrustStrip />
      <MissionSection />
      <ServicesSection />
      <FeaturedProperty />
      <DRInvestSection />
      <PropertyPrepSection />
      <AboutPreviewSection />
      <TestimonialsSection />
      <AreasWeServeSection />
      <MapSection />
      <FinalCTASection />
    </SiteLayout>
  );
};

export default Index;
